/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   toSlug
 */

import { hyphenate, unaccent } from '../../../../shared/utils/core.js'

/**
 *
 * @param {string | null | undefined} cityName
 * @param {string | null | undefined} state
 * @param {string | null | undefined} [hoodName]
 * @returns {string}
 */
export const toSlug = (cityName, state, hoodName) => {
  if (!cityName) {
    return ''
  }

  const slug = `${hyphenate(unaccent(cityName)).toLowerCase()}-${state?.toLowerCase()}${
    hoodName ? `/${hyphenate(unaccent(hoodName)).toLowerCase()}` : ''
  }`

  return slug
}
